export const API_ENDPOINTS = {
  ASR: "/api/asr/",
  BOT_VERNACULAR: "/api/bot_vernacular/",
  CREATE_USER_PROFILE: "/api/create-profile/",
  FLOW_CONNECTION_INFO: "/api/flow-connection-info/",
  FLOW_LANGUAGES: "/api/flow-languages/",
  GENERATE_SESSION: "/api/generate-session/",
  GET_CHAT_SESSION: "/api/chatsession/",
  GET_COMPANY_BOT: "/api/companybot/",
  GET_IP_LOCATION: "/api/get-ip-location/",
  GET_LOCATION: "/api/get-location/",
  GET_PRESIGNED_URL: "/api/get-presigned-url/",
  GET_PROFILE_DETAILS: "/api/profile/",
  GET_STORY: "/api/get-story",
  GET_USER_PROFILE: "/api/user_profile",
  LOGIN: "/api/login/",
  LOGOUT: "/api/logout/",
  PROFILE_USER: "/api/profileuser/",
  READ_ELEVATE_PROFILE: "/api/shikshalokam/read-elevate-profile/",
  SAVE_PTM_QUESTION: "/api/questions/save/",
  STORY_MEDIA: "/api/storymedia/",
  STORY: "/api/story/",
  SUBMIT_FEEDBACK: "/api/feedback/",
  TEXT_TO_SPEECH: "/api/text_to_speech/",
  TEXT_TRANSLITERATE: "/api/text_transliterate/",
  UPDATE_PROJECT_STATUS: "/api/shikshalokam/update-project-status/",
  END_STORY: "/api/end-story/",
  END_STORY_V2: "/api/end-story/v2/",
  // mitra chat
  PARAPHRASE_API: "api/paraphrase/",
  OBJECTIVE_API: "api/shikshalokam/generate-objective/",
  ACTION_LIST_API: "api/shikshalokam/generate-action-list/",
  TITLE_API: "api/shikshalokam/generate-title/",
  SAVE_COMPANY_CHAT: "api/save-company-chat/",
  GET_COMPANY_CHAT: "api/companychat/",
  GENERATE_SESSION_ID: "api/generate-session/",
  CREATE_CHAT_SESSION: "api/create-chatsession/",
  CHAT_SESSION: "api/chatsession/",
  CREATE_PROJECT: "api/create-project/",
  VALIDATE_OBJECTIVE: "api/shikshalokam/validate-objective/",
  VALIDATE_ACTIONS: "api/shikshalokam/validate-actions/",
  VALIDATE_TITLE: "api/shikshalokam/validate-title/",
  PARAPHRASE: "api/shikshalokam/paraphrase/",
  NON_LLM_CHAT: "api/non-llm-chat/",
}

export const URL_PARAMS = {
  ACCESS_TOKEN: "accToken",
  FLOW: "flow",
  PROJECT_ID: "projectId",
  TASK_ID: "taskId",
  SESSION_ID: "sessionId",
  LANGUAGE: "language",
  RE_ROUTE_URL: "rerouteUrl",
}
